import { queryOptions, skipToken } from '@tanstack/react-query';

import { getProfile } from './api';

export const profileQueries = {
  all: (group: string) => ['profile', group] as const,
  detail: (group: string) =>
    queryOptions({
      queryKey: profileQueries.all(group),
      queryFn: group ? () => getProfile(group) : skipToken,
    }),
};
